import { RootState } from 'app/store';

import { AppModules } from 'constants/enums';

export const selectModuleFilters = (module: AppModules) => (state: RootState) =>
  state.moduleConfigs?.configs[module]?.filters;

export const selectActiveModule = (state: RootState): AppModules | null =>
  state.moduleConfigs.activeModule;

export const selectModuleFiltersLoading =
  (module: AppModules) =>
  (state: RootState): boolean =>
    state.moduleConfigs?.configs[module]?.isFiltersLoading ?? false;

export const selectModuleConfig = (module: AppModules) => (state: RootState) =>
  state.moduleConfigs?.configs[module];
